var hdd = "https://shopfront-cdn.tekoapis.com/static/e95dec823dfc9cba.svg";

export { hdd as default };
